import type { SerializedStyles, Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

import type { Variant } from '../../banner'

export const text = css`
  letter-spacing: -0.01em;
  grid-area: title;
  justify-self: start;
  text-align: start;
  margin-bottom: ${size[4]};
`

export const textVariant: Record<Variant, (theme: Theme) => SerializedStyles> =
  {
    primary: (theme) => css`
      color: ${theme.palette.brand[500]};
    `,
    secondary: (theme) => css`
      color: ${theme.palette.neutral[800]};
    `,
    warning: (theme) => css`
      color: ${theme.palette.warning[500]};
    `,
    error: (theme) => css`
      color: ${theme.palette.error[500]};
    `,
  }

export const textUppercase = css`
  text-transform: uppercase;
  letter-spacing: initial;
  margin-bottom: 0;

  ${breakpoint.up('sm')} {
    margin-bottom: ${size[4]};
  }
`
